import { useStanQuery } from '@/queries';
import { fetchEmailTemplate } from '../analytics.logic';
import { QUERY_KEYS, SENTRY_FEATURES } from '@/lib';

export function useAffiliateEmailTemplate() {
    return useStanQuery({
        queryKey: [QUERY_KEYS.AFFILIATE_EMAIL_TEMPLATE],
        queryFn: fetchEmailTemplate,
        staleTime: 1000 * 60 * 5, // 5 minutes
        meta: {
            error: {
                sentryMessage: '[ANALYTICS] failed-to-fetch-affiliate-email-template',
                feature: SENTRY_FEATURES.ANALYTICS,
            },
        },
    });
}
